import Swal from 'sweetalert2'

const CHUNK_ERROR_PATTERNS = [
	/failed to fetch dynamically imported module/i,
	/importing a module script failed/i,
	/error loading dynamically imported module/i,
	/'text\/html' is not a valid javascript mime type/i,
	/unexpected token '<'/i,
	/chunkloaderror/i,
	/failed to load module script/i,
]

let reloadPromptOpen = false

/**
 * @param {unknown} error
 * @returns {boolean}
 */
export function isCheckoutChunkLoadError(error) {
	const message = error?.message || String(error || '')
	return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

/**
 * Prompt the user to reload after a stale deploy or failed checkout chunk load.
 */
export async function promptCheckoutReload() {
	if (reloadPromptOpen) return
	reloadPromptOpen = true

	try {
		const result = await Swal.fire({
			icon: 'warning',
			title: 'Checkout needs a refresh',
			text: 'This page was open during a site update. Please reload to continue checkout.',
			confirmButtonText: 'Reload page',
			confirmButtonColor: '#e59789',
			allowOutsideClick: false,
		})

		if (result.isConfirmed) {
			window.location.reload()
		}
	} finally {
		reloadPromptOpen = false
	}
}
